export default "<p>next-rewards works!</p>\n"